const agent = {
  supervisor: process.env.NEXT_PUBLIC_SUPERVISOR,
  assistantId: process.env.NEXT_PUBLIC_ASITANT_ID,
}

export default agent
